import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/icons/jb-spotify-icon/jb-spotify-icon.scss?inline
var jb_spotify_icon_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  cursor: pointer;
  display: inline-flex;
}

svg {
  fill: currentcolor;
  height: var(--icon-height, 24px);
  width: var(--icon-width, 24px);
}`;

// src/components/icons/jb-spotify-icon/jb-spotify-icon.ts
var JbSpotifyIcon = class extends h {
  render() {
    return ke`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 12.0001C0 5.37268 5.37269 0 11.9999 0L11.9998 0.000573192C18.6279 0.000573192 24 5.37311 24 12.0001C24 18.6278 18.6279 24 11.9999 24C5.37269 24 0 18.6278 0 12.0001ZM16.4742 17.5555C16.8267 17.7718 17.2881 17.6601 17.503 17.3075C17.7194 16.955 17.6076 16.495 17.2551 16.2787C14.092 14.3456 10.1711 13.8955 5.59996 14.9403C5.19644 15.032 4.94524 15.4332 5.03738 15.8359C5.12909 16.2385 5.53032 16.4907 5.93283 16.399C10.1099 15.4447 13.6567 15.8344 16.4742 17.5555ZM18.9718 14.0396C18.701 14.4803 18.1249 14.6193 17.685 14.3484C14.4594 12.3653 9.54257 11.7911 5.72735 12.9493C5.23255 13.0987 4.70995 12.8199 4.55978 12.3259C4.41075 11.8311 4.68975 11.3095 5.18369 11.1591C9.54171 9.8367 14.9595 10.4772 18.6637 12.7535C19.1036 13.0244 19.2426 13.6004 18.9718 14.0398V14.0396ZM5.15689 9.24946C8.84945 8.12873 15.2304 8.33995 19.0979 10.6372H19.0985C19.6301 10.9539 20.3208 10.778 20.636 10.2447C20.9527 9.71203 20.7779 9.0232 20.2434 8.70665C15.7906 6.06323 8.74413 5.81461 4.50533 7.10143C3.91195 7.28169 3.5775 7.90834 3.75719 8.50159C3.93688 9.09456 4.56394 9.4293 5.15689 9.24946Z"
        />
      </svg>
    `;
  }
};
JbSpotifyIcon.styles = r(jb_spotify_icon_default);
JbSpotifyIcon = __decorateClass([
  customElement("jb-spotify-icon")
], JbSpotifyIcon);

export {
  JbSpotifyIcon
};
